import 'tinymce';
import TinyMCEConfig from './tinymce/config';

window.TinyMCEConfig = TinyMCEConfig;
